import { createRouter, createWebHashHistory } from "vue-router";
import {
  checkAuthorization,
  removeAuthorization,
  setAuthorization,
} from "@/utils/request";
import { RefreshToken } from "@/services/login";
import Janus from "@/assets/js/janus";

//路由定义写在这里.
const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    name: "login",
    path: "/login",
    component: () => import("./pages/login/login"),
    meta: {
      title: "login",
    },
  },
  {
    name: "verification",
    path: "/verification",
    component: () => import("./pages/login/verification"),
    meta: {
      title: "検証",
    },
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("./pages/dashboard/dashboard"),
    meta: {
      title: "ホーム",
    },
  },
  {
    name: "patientindex",
    path: "/patientindex",
    component: () => import("./pages/patientindex/patientindex"),
    meta: {
      title: "patientindex",
    },
  },
  {
    name: "familyHome",
    path: "/familyHome",
    component: () => import("./pages/family/familyHome"),
    meta: {
      title: "家族通話",
    },
  },
  {
    name: "patientrecord",
    path: "/patientrecord",
    component: () => import("./pages/patientindex/record"),
    meta: {
      title: "patientrecord",
    },
  },
  {
    name: "stand",
    path: "/stand",
    component: () => import("./pages/stand/stand"),
    meta: {
      title: "stand Page",
    },
  },
  {
    name: "user",
    path: "/user",
    component: () => import("./pages/user/user"),
    meta: {
      title: "マイページ",
    },
  },
  {
    name: "sensor",
    path: "/sensor",
    component: () => import("./pages/sensor/sensor"),
    meta: {
      title: "センサー",
    },
  },
  {
    name: "userLostPass",
    path: "/userLostPass",
    component: () => import("./pages/user/userLostPass"),
    meta: {
      title: "メールボックスの検証",
    },
  },
  {
    name: "verifyUserLoginId",
    path: "/verifyUserLoginId",
    component: () => import("./pages/user/verifyUserLoginId"),
    meta: {
      title: "パスワード変更",
    },
  },
  {
    name: "userLostPassCode",
    path: "/userLostPassCode",
    component: () => import("./pages/user/userLostPassCode"),
    meta: {
      title: "認証コード",
    },
  },
  {
    name: "userPasswordVerify",
    path: "/userPasswordVerify",
    component: () => import("./pages/user/userPasswordVerify"),
    meta: {
      title: "パスワード検証",
    },
  },
  {
    name: "userPasswordUpdate",
    path: "/userPasswordUpdate",
    component: () => import("./pages/user/userPasswordUpdate"),
    meta: {
      title: "パスワード変更",
    },
  },
  {
    name: "userRinging",
    path: "/userRinging",
    component: () => import("./pages/user/userRinging"),
    meta: {
      title: "着信音",
    },
  },
  {
    name: "ringingChoose",
    path: "/ringingChoose",
    component: () => import("./pages/user/ringingChoose"),
    meta: {
      title: "通話着信音",
    },
  },
  {
    name: "ringingMsgChoose",
    path: "/ringingMsgChoose",
    component: () => import("./pages/user/ringingMsgChoose"),
    meta: {
      title: "メッセージ着信音",
    },
  },
  {
    name: "authentication",
    path: "/authentication",
    component: () => import("./pages/user/authentication"),
    meta: {
      title: "二段階認証",
    },
  },
  {
    name: "userInfo",
    path: "/userInfo",
    component: () => import("./pages/user/userInfo"),
    meta: {
      title: "プロフィール",
    },
  },
  {
    name: "binahData",
    path: "/binahData",
    component: () => import("./pages/user/binahData"),
    meta: {
      title: "ビナーデータ",
    },
  },
  {
    name: "PatientListBinah",
    path: "/PatientListBinah",
    component: () => import("./pages/patient/PatientListBinah"),
    meta: {
      title: "シンプルリスト",
    },
  },
  {
    name: "PatientList",
    path: "/PatientList",
    component: () => import("./pages/patient/PatientList"),
    meta: {
      title: "ユーザー一覧",
    },
  },
  // {
  //   name: 'PatientInfo',
  //   path: '/PatientInfo',
  //   component: () => import('./pages/patient/PatientInfo'),
  //   meta: {
  //     title: 'シンプルの詳細',
  //   },
  // },
  {
    name: "monitorList",
    path: "/monitorList",
    component: () => import("./pages/patient/monitorList"),
    meta: {
      title: "見守りモード",
    },
  },
  {
    name: "monitorRoom",
    path: "/monitorRoom",
    component: () => import("./pages/patient/monitorRoom"),
    meta: {
      title: "見守りカメラ",
    },
  },
  /* {
    name: 'doctorList',
    path: '/doctorList',
    component: () => import('./pages/team/doctorList'),
    meta: {
      title: '一般ユーザ一覧',
    },
  }, */
  {
    name: "teamList",
    path: "/teamList",
    component: () => import("./pages/team/teamList"),
    meta: {
      title: "通話",
    },
  },
  {
    name: "log",
    path: "/log",
    component: () => import("./pages/log/log"),
    meta: {
      title: "ログ",
    },
  },
  {
    name: "roomEdit",
    path: "/roomEdit",
    component: () => import("./pages/room/roomEdit"),
    meta: {
      title: "ルーム編集",
    },
  },
  {
    name: "roomAdd",
    path: "/roomAdd",
    component: () => import("./pages/room/roomAdd"),
    meta: {
      title: "ルーム追加",
    },
  },
  {
    name: "roomList",
    path: "/roomList",
    component: () => import("./pages/room/roomList"),
    meta: {
      title: "ルーム一覧",
    },
  },
  {
    name: "recordLog",
    path: "/recordLog",
    component: () => import("./pages/log/recordLog"),
    meta: {
      title: "録画一覧",
    },
  },
  {
    name: "recordDetail",
    path: "/recordDetail",
    component: () => import("./pages/log/recordDetail"),
    meta: {
      title: "録画詳細",
    },
  },
  {
    name: "waitBackground",
    path: "/waitBackground",
    component: () => import("./pages/patientindex/waitBackground"),
    meta: {
      title: "待ち受け画面",
    },
  },
  {
    name: "patientWaitBackground",
    path: "/patientWaitBackground",
    component: () => import("./pages/patient/patientWaitBackground"),
    meta: {
      title: "シンプルリスト",
    },
  },
  {
    name: "notice",
    path: "/notice",
    component: () => import("./pages/notice/notice"),
    meta: {
      title: "通知一覧",
    },
  },
  {
    name: "chatList",
    path: "/chatList",
    component: () => import("./pages/chat/chatList"),
    meta: {
      title: "Chat一覧",
    },
  },
  {
    name: "chatDetail",
    path: "/chatDetail",
    component: () => import("./pages/chat/chatDetail"),
    meta: {
      title: "Chat",
    },
  },
  {
    name: "chatToPatient",
    path: "/chatToPatient",
    component: () => import("./pages/chat/chatToPatient"),
    meta: {
      title: "シンプルユーザへの発信",
    },
  },
  {
    name: "audioBridge",
    path: "/audioBridge",
    component: () => import("./pages/room/audioBridge"),
    meta: {
      title: "インカム",
    },
  },
  {
    name: "audioBridgeList",
    path: "/audioBridgeList",
    component: () => import("./pages/room/audioBridgeList"),
    meta: {
      title: "インカム",
    },
  },
  {
    name: "beforeRoom",
    path: "/beforeRoom",
    component: () => import("./pages/room/beforeRoom"),
    meta: {
      title: "通話",
    },
  },
  {
    name: "beforeCall",
    path: "/beforeCall",
    component: () => import("./pages/team/beforeCall"),
    meta: {
      title: "通話",
    },
  },
  {
    name: "roomConversation",
    path: "/roomConversation",
    component: () => import("./pages/room/roomConversation"),
    meta: {
      title: "ルーム通話",
    },
  },
  {
    name: "webSpeech",
    path: "/webSpeech",
    component: () => import("./pages/speech/webSpeech"),
    meta: {
      title: "Speech to text(webSpeech)",
    },
  },
  {
    name: "singleCall",
    path: "/singleCall",
    component: () => import("./pages/conversation/singleCall"),
    meta: {
      title: "通話",
    },
  },
  {
    name: "dzPage",
    path: "/dzPage",
    component: () => import("./pages/dz/dzPage"),
    meta: {
      title: "DZ認証",
    },
  },
  {
    name: "roomReservation",
    path: "/roomReservation",
    component: () => import("./pages/user/roomReservation"),
    meta: {
      title: "ルーム予約",
    },
  },
  {
    name: "userCalendar",
    path: "/userCalendar",
    component: () => import("./pages/user/userCalendar"),
    meta: {
      title: "個人スケジュール",
    },
  },
  {
    name: "roomCalendar",
    path: "/roomCalendar",
    component: () => import("./pages/user/roomCalendar"),
    meta: {
      title: "ルーム予約",
    },
  },
  {
    name: "timeDisplaySize",
    path: "/timeDisplaySize",
    component: () => import("./pages/user/timeDisplaySize"),
    meta: {
      title: "時間表示サイズ",
    },
  },
  {
    name: "fullScreenCallDisplaySize",
    path: "/fullScreenCallDisplaySize",
    component: () => import("./pages/user/fullScreenCallDisplaySize"),
    meta: {
      title: "フルスクリーンコール文字サイズ",
    },
  },
  {
    name: "openCall",
    path: "/openCall",
    component: () => import("./pages/open/openCall"),
    meta: {
      title: "open_call_test",
    },
  },
  {
    name: "aiAnalysis",
    path: "/aiAnalysis",
    component: () => import("./pages/ai/aiAnalysis"),
    meta: {
      title: "AI分析状態確認",
    },
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/dashboard",
  },
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

const loginIgnore = {
  names: ["404", "403"], //根据路由名称匹配
  paths: ["/login", "/verification", "/verifyUserLoginId", "/openCall"], //根据路由fullPath匹配
  includes(route) {
    return this.names.includes(route.name) || this.paths.includes(route.path);
  },
};

const patientAllowedPaths = [
  "/user",
  "/patientindex",
  "/ringingChoose",
  "/ringingMsgChoose",
  "/userRinging",
  "/userPassword",
  "/monitorRoom",
  "/userInfo",
  "/binahData",
  "/authentication",
  "/waitBackground",
  "/timeDisplaySize",
  "/fullScreenCallDisplaySize",
  "/singleCall",
  "/toPatientChatList",
  "/userPasswordVerify",
  "/userPasswordUpdate",
  "/userLostPass",
  "/userLostPassCode",
  "/dzPage",
  "/roomConversation",
  "/patientrecord",
];

const familyAllowedPaths = ["/familyHome", "/beforeCall", "/singleCall"];

router.beforeEach(async (to, from, next) => {
  if (!loginIgnore.includes(to) && !checkAuthorization()) {
    // refresh_token check
    let refreshtoken = localStorage.getItem("refreshtoken");
    let check = false;
    if (
      refreshtoken !== undefined &&
      refreshtoken != null &&
      refreshtoken !== ""
    ) {
      let ret = await RefreshToken({ refreshtoken: refreshtoken });
      if (ret && ret.data && ret.data.code && ret.data.code == -1) {
        check = true;
        //清空refreshtoken一定要小心
        localStorage.removeItem("refreshtoken");
      } else if (
        ret &&
        ret.data &&
        ret.data.data &&
        ret.data.data.status &&
        ret.data.data.status == "refresh_need"
      ) {
        let expireAt_T = ret.data.data.expireAt.replace(" ", "T");
        setAuthorization({
          token: ret.data.data.newToken,
          expireAt: new Date(expireAt_T),
        });
        next();
      } else {
        localStorage.removeItem("refreshtoken");
        check = true;
      }
    } else {
      check = true;
    }
    if (check) {
      if (Janus) {
        Janus.videoPageDestory();
      }
      const code = localStorage.getItem(process.env.VUE_APP_CODE_KEY);
      removeAuthorization();

      // 会议邮件中点击的URL保存到sessionStorage中
      if (to.query.savePathFlg == "1") {
        sessionStorage.setItem("redirectUrl", to.fullPath);
      }

      next({ path: "/login", query: { code: code } });
    }
  } else {
    if (checkAuthorization()) {
      let userInfo = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_KEY)
      );
      if (!userInfo) {
        next();
        return;
      }
      if (to.path === "/login" || to.path === "/verification") {
        if (userInfo.type == "4") {
          next({ path: "/dashboard" });
          return;
        } else if (userInfo.type == "5") {
          next({ path: "/patientindex" });
          return;
        } else if (userInfo.type == "6") {
          next({ path: "/familyHome" });
          return;
        }
        next();
        return;
      } else if (
        userInfo.type == "5" &&
        !patientAllowedPaths.includes(to.path)
      ) {
        next({ path: "/patientindex" });
      } else if (
        userInfo.type == "6" &&
        !familyAllowedPaths.includes(to.path)
      ) {
        next({ path: "/familyHome" });
      } else if (userInfo.type == "4" && to.path === "/patientindex") {
        next({ path: "/dashboard" });
      } else {
        //进入正常页面
        if (to.path == "/singleCall") {
          next();
        } else {
          next();
        }
      }
    } else {
      next();
    }
  }
});

export { router, loginIgnore };
